import React, { FC } from 'react';
import { Resources } from '@erecruit/types';
import { FormItem, H1 } from '@erecruit/ui-kit';
import { CustomFieldRenderer } from '@erecruit/modules';
import { Intl } from '@erecruit/core';
import { Disclaimer } from '../Disclaimer';

const { FormattedMessage } = Intl;
interface AdditionalInfoStepProps {
  fields: Resources.CustomField[];
  showHeader: boolean;
}

export const AdditionalInfoStep: FC<AdditionalInfoStepProps> = props => (
  <>
    {props.showHeader && (
      <>
        <H1>
          <FormattedMessage
            id={messageIds.vms.newPositionWizard.additionalInfo.title}
          />
        </H1>
        <Disclaimer>
          <FormattedMessage
            id={messageIds.vms.newPositionWizard.additionalInfo.disclaimer}
          />
        </Disclaimer>
      </>
    )}

    {props.fields.map(field => {
      const { value, ...rendererProps } = field;
      return (
        <FormItem
          key={field.id}
          id={String(field.id)}
          label={field.name}
          hasFeedback
          options={{
            initialValue: value,
            rules: [
              {
                required: field.settings && field.settings.required,
                message: (
                  <FormattedMessage
                    id={messageIds.vms.errors.form.requiredField}
                  />
                ),
              },
            ],
          }}
        >
          <CustomFieldRenderer {...rendererProps} mode="edit" />
        </FormItem>
      );
    })}
  </>
);
